import styled, { css } from 'styled-components';

export const WrapperAvatar = styled.div<{
  hasOpacity: boolean;
  onClick?: () => void;
}>`
  ${({ hasOpacity, onClick }) => css`
    ${hasOpacity &&
    css`
      opacity: 24%;
    `}

    ${!!onClick &&
    css`
      cursor: pointer;
    `}
  `}
`;
